exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label.required[data-v-4493337f]:after {\n  content: \"*\";\n  color: red;\n}", ""]);

// exports
